"use client";

import { useEffect, useState } from "react";

/**
 * Hook that detects if the current device has touch as the primary input.
 * Uses the media query (pointer: coarse) for consistency with CSS detection.
 * @returns Boolean indicating if the device is touch-primary, or undefined during SSR
 */
export const useIsTouchDevice = (): boolean | undefined => {
  const [isTouchDevice, setIsTouchDevice] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(pointer: coarse)");

    const handleChange = () => {
      setIsTouchDevice(mediaQuery.matches);
    };

    // Set initial value
    handleChange();

    // Listen for changes
    mediaQuery.addEventListener("change", handleChange);

    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return isTouchDevice;
};
